// eslint-disable-next-line jira/filename-case
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';

export const useIsReadOnly = (): boolean => {
	const { hasProductDiscoveryAccess } = useApplicationPermissions();
	return !hasProductDiscoveryAccess;
};
